/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { IInvoice } from '.';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';
import { ICourseSubscriptionSession } from '../StripeSlice';

const apiDataProvider = new APIDataProvider();

export const getInvoiceById = createAsyncThunk(
  '/invoices/getOne',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<IInvoice>>(
      `${ApiPaths.invoices}/${id}`
    );

    return response.data;
  }
);

export const createStripeInvoiceSession = createAsyncThunk(
  '/invoices/stripe/session/create',
  async (id: string) => {
    const response = await apiDataProvider.post<
      TApiResponse<ICourseSubscriptionSession>
    >(`${ApiPaths.invoices}/stripe/session/${id}`, {
      id,
    });

    return response.data;
  }
);
